// extracted by mini-css-extract-plugin
export default {"container":"ButtonReplace_container__Gj+sC","icon":"ButtonReplace_icon__k+6-j","label":"ButtonReplace_label__l7weS"};